import React from 'react';
import { EntityType } from '../../constants';
import { CallActionButton, CallActionProps } from './CallActionButton.component';
import { AnalyticsAction, AnalyticsCategory } from '../../analytics-new/analytics.models';
import { defineMessages } from 'react-intl';
import { BulbInactiveIcon } from '@getgo/chameleon-icons/react';

const definedMessage = defineMessages({
  NEW_OPPORTUNITY: {
    id: 'Call.NewOpportunity',
    defaultMessage: 'New opportunity',
  },
});

export const NewOpportunityButton: React.FC<Partial<CallActionProps>> = (props) => {
  return (
    <CallActionButton
      leadingIcon={<BulbInactiveIcon aria-hidden />}
      label={definedMessage.NEW_OPPORTUNITY}
      entityType={EntityType.OPPORTUNITY}
      variant="custom"
      trackingEvent={{
        category: AnalyticsCategory.Call,
        action: AnalyticsAction.ItemClicked,
        label: 'New opportunity | button',
      }}
      {...props}
    />
  );
};
